import { useContext, useEffect, useState } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { XmppContext } from "@/stream/xmppClient"
import AdHocCommands from "@/api/adHocCommands"
import { parseNaviJson } from "@/lib/naviParser"

export function useNaviConfig(vhost?: string): {
  configured: boolean
  loading: boolean
} {
  const { client } = useContext(XmppContext)
  const marcosEnabled = useFeatureFlagEnabled("marcos-integration")
  const [configured, setConfigured] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    if (!client || !vhost || !marcosEnabled) {
      setLoading(false)
      return
    }
    setLoading(true)
    AdHocCommands.getNaviConfig(client, vhost)
      .then((res) => {
        if (cancelled) return
        setConfigured(Boolean(parseNaviJson(res)?.configured))
      })
      .catch(() => !cancelled && setConfigured(false))
      .finally(() => !cancelled && setLoading(false))
    return () => {
      cancelled = true
    }
  }, [client, vhost, marcosEnabled])

  return { configured, loading }
}
